import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../contexts/UserContext";
import "./styles/ReportButton.css";

interface ReportButtonProps {
  onClick: () => void;
}

const ReportButton: React.FC<ReportButtonProps> = memo(({ onClick }) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useUserContext();

  const handleClick = useCallback(() => {
    if (!isLoggedIn) {
      // TODO: Navigate to login/auth page
      alert(t("auth.pleaseLogin"));
      return;
    }
    onClick();
  }, [isLoggedIn, onClick, t]);

  return (
    <button className="report-button" onClick={handleClick}>
      {t("report.report")}
    </button>
  );
});

ReportButton.displayName = "ReportButton";

export default ReportButton;

